import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { API } from "@/config/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { toast } from "sonner";
import axios from "axios";
import { Lock, ArrowRight } from "lucide-react";

const AccessCodePage = () => {
  const navigate = useNavigate();
  const { grantAccess, accessGranted } = useAuth();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Redirect if already has access
  React.useEffect(() => {
    if (accessGranted) {
      navigate("/nda");
    }
  }, [accessGranted, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      console.log("API URL:", API);
      const response = await axios.post(`${API}/access/verify`, { access_code: code });
      grantAccess();
      toast.success("Access granted! Welcome to Board2Boston™");
      // navigate("/nda");
    } catch (err) {
      console.error(err);
      
      setError("Invalid access code. Please try again.");
      toast.error("Invalid access code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-8 relative"
      style={{
        background: "radial-gradient(ellipse at center, rgba(122, 98, 0, 0.15) 0%, #050505 70%)"
      }}
      data-testid="access-code-page"
    >
      {/* Back to splash */}
      <button
        onClick={() => navigate("/")}
        className="absolute top-6 left-6 text-[#A1A1AA] hover:text-white transition-colors font-ubuntu text-sm flex items-center gap-2"
        data-testid="back-button"
      >
        ← Back
      </button>

      <Card className="w-full max-w-md bg-[#0A0A0A] border border-[#7a6200]/30 shadow-[0_0_40px_rgba(122,98,0,0.15)]">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-[#7a6200]/20 flex items-center justify-center">
            <Lock className="w-8 h-8 text-[#7a6200]" />
          </div>
          <CardTitle className="font-bebas text-4xl tracking-wider text-white">
            INVITATION ONLY
          </CardTitle>
          <CardDescription className="text-[#A1A1AA] font-ubuntu mt-2">
            Enter your access code to continue
          </CardDescription>
        </CardHeader>

        <CardContent className="pt-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Input
                type="password"
                placeholder="••••••••••"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                className="input-dark h-14 text-center text-xl tracking-widest font-bebas uppercase"
                data-testid="access-code-input"
                autoFocus
                autoComplete="off"
              />
              {error && (
                <p className="text-red-500 text-sm mt-2 text-center font-ubuntu">
                  {error}
                </p>
              )}
            </div>

            <Button
              type="submit"
              className="btn-gold w-full h-14 text-lg"
              disabled={loading || !code}
              data-testid="submit-access-code"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  VERIFYING...
                </span>
              ) : (
                <span className="flex items-center gap-2">
                  CONTINUE <ArrowRight className="w-5 h-5" />
                </span>
              )}
            </Button>
          </form>

          <div className="mt-8 pt-6 border-t border-white/10 text-center">
            <p className="text-[#52525B] text-sm font-ubuntu">
              Don't have an access code?
            </p>
            <p className="text-[#A1A1AA] text-sm font-ubuntu mt-1">
              Contact us at{" "}
              <a href="mailto:713consulting@gmail.com" className="text-[#7a6200] hover:text-[#C6A300] transition-colors">
                713consulting@gmail.com
              </a>
            </p>
          </div>
        </CardContent>
      </Card>

      {/* Logo watermark */}
      <div className="absolute bottom-8 opacity-30">
        <img
          src="https://customer-assets.emergentagent.com/job_hoop-invite/artifacts/r8lcaocz_Board2Boston%20favicon.png"
          alt="Board2Boston"
          className="h-16"
        />
      </div>
    </div>
  );
};

export default AccessCodePage;
